/* eslint-disable no-process-env */
export const isProductionEnv = () => process.env.NODE_ENV === 'production';

export const isTestEnv = () => process.env.NODE_ENV === 'test';
export const getSentryDsn = () => process.env.REACT_APP_SENTRY_DSN;
export const getVersion = () => process.env.REACT_APP_VERSION || 'dev';
